import type { DesignTokenSizeEnum } from '@volkswagen-onehub/components-core';
import { type HTMLAttributes } from 'react';
import type { BreakpointsProps } from '@/types';
import { StyledBox } from './Box.styles';

export interface BoxBaseProps {
  position?: string;
  zIndex?: string | number;
  top?: string | number;
  bottom?: string | number;
  left?: string | number;
  right?: string | number;
  width?: string | number;
  minWidth?: string | number;
  maxWidth?: string | number;
  height?: string | number;
  minHeight?: string | number;
  maxHeight?: string | number;
  display?: string | number;
  visibility?: string;
  alignItems?: string | number;
  justifyContent?: string;
  flexGrow?: string | number;
  flexShrink?: string | number;
  flexDirection?: string;
  flexBasis?: string;
  gap?: keyof typeof DesignTokenSizeEnum;
  px?: keyof typeof DesignTokenSizeEnum;
  py?: keyof typeof DesignTokenSizeEnum;
  p?: keyof typeof DesignTokenSizeEnum;
  pl?: keyof typeof DesignTokenSizeEnum;
  pr?: keyof typeof DesignTokenSizeEnum;
  pt?: keyof typeof DesignTokenSizeEnum;
  pb?: keyof typeof DesignTokenSizeEnum;
  padding?: keyof typeof DesignTokenSizeEnum;
  paddingLeft?: keyof typeof DesignTokenSizeEnum;
  paddingBottom?: keyof typeof DesignTokenSizeEnum;
  paddingRight?: keyof typeof DesignTokenSizeEnum;
  paddingTop?: keyof typeof DesignTokenSizeEnum;
  mx?: keyof typeof DesignTokenSizeEnum;
  my?: keyof typeof DesignTokenSizeEnum;
  m?: keyof typeof DesignTokenSizeEnum;
  ml?: keyof typeof DesignTokenSizeEnum;
  mr?: keyof typeof DesignTokenSizeEnum;
  mt?: keyof typeof DesignTokenSizeEnum;
  mb?: keyof typeof DesignTokenSizeEnum;
  margin?: keyof typeof DesignTokenSizeEnum;
  marginLeft?: keyof typeof DesignTokenSizeEnum;
  marginBottom?: keyof typeof DesignTokenSizeEnum;
  marginRight?: keyof typeof DesignTokenSizeEnum;
  marginTop?: keyof typeof DesignTokenSizeEnum;
  cursor?: string;
  border?: string;
  borderRadius?: string;
  color?: string;
  whiteSpace?: string;
}

export interface BoxProps
  extends Omit<HTMLAttributes<HTMLElement>, 'style' | 'color'>,
    BreakpointsProps<BoxBaseProps>,
    BoxBaseProps {
  as?: React.ElementType;
}

const Box = <T extends BoxProps>(props: T) => <StyledBox {...props} />;

export default Box;
